<template>
  <div class="personal-header">
    <div class="bd">
      <div class="logo" title="元气桌面" />
      <div class="r">
        <div class="download-tip" />
        <a :href="transformProtocol(info.install_pkg)" rel="noopener noreferrer" class="btn-download">点击下载</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PersonalHeader',
  props: {
    info: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {}
  },
  methods: {
    transformProtocol(value) {
      if (typeof value === 'string') {
        return value.replace(/https?:/, '')
      }

      return value
    },
  },
}
</script>

<style scoped lang="scss">
.personal-header {
  height: 100px;
  background: #fff;
  .bd {
    width: 1280px;
    margin: 0 auto;
  }
  .logo {
    float: left;
    width: 128px;
    height: 69px;
    margin-top: 15px;
    background: url('~@/assets/images/logo-b.png') 0 0 no-repeat;
    background-size: 100%;
  }
  .r {
    float: right;
    .btn-download,
    .download-tip {
      vertical-align: middle;
    }
    .download-tip {
      margin: 6px 10px 0 0;
    }
  }
  .download-tip {
    display: inline-block;
    width: 282px;
    height: 84px;
    background: url('~@/assets/images/install-banner.png') 0 0 no-repeat;
  }
  .btn-download {
    display: inline-block;
    height: 44px;
    padding: 0 36px;
    line-height: 44px;
    font-size: 14px;
    box-shadow: 0px 8px 12px 0px rgba(244, 194, 41, 0.56);
    border-radius: 10px;
    background: #f4c000;
    color: #000;
    cursor: pointer;
    &:hover {
      background: #ffda53;
    }
    &:active {
      background: #dfaf00;
    }
  }
}
</style>
